import { render, staticRenderFns } from "./MassCustomerCategoriesHistorySection.vue?vue&type=template&id=0d95be0c&scoped=true&"
import script from "./MassCustomerCategoriesHistorySection.vue?vue&type=script&lang=js&"
export * from "./MassCustomerCategoriesHistorySection.vue?vue&type=script&lang=js&"
import style0 from "./MassCustomerCategoriesHistorySection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MassCustomerCategoriesHistorySection.vue?vue&type=style&index=1&id=0d95be0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95be0c",
  null
  
)

export default component.exports